import { render, staticRenderFns } from "./ApplicationSubmissionsRoomType.vue?vue&type=template&id=2ac3a28a&lang=pug&"
import script from "./ApplicationSubmissionsRoomType.vue?vue&type=script&lang=js&"
export * from "./ApplicationSubmissionsRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports